import { Button } from "@mui/material";
import { GiftCardInfoData } from "../data/shared";

type DenominationViewProps = {
  voucherValue: number;
  denominations?: number[];
  gift: GiftCardInfoData;
  onChange?: (value) => void;
};
export const DenominationView = ({ voucherValue, denominations = [], gift, onChange = () => {} }: DenominationViewProps) => {
  return (
    <div style={{ display: "grid", gap: "0.3125rem", marginTop: "1.25rem", gridTemplateColumns: "repeat(4, 1fr)" }}>
      {denominations.map((denomination) => (
        <Button
          key={denomination}
          sx={{
            borderRadius: "0.75rem",
            height: "40px",
            "&.MuiButton-containedPrimary.MuiButton-root": {
              backgroundColor: "primary.main",
            },
          }}
          onClick={() => onChange(denomination)}
          color={denomination === voucherValue ? "secondary" : "primary"}
        >
          {gift.currency}
          {denomination}
        </Button>
      ))}
    </div>
  );
};
